import React from "react";

const Footer = () => {
  return (
    <footer className="footer-wrapper footer-default bg-footer-color">
      {/* Top Shape */}
      <div
        className="shape-mockup d-none d-xxl-block"
        style={{ top: 0, left: 0 }}
      >
        <img
          src="/img/shape/footer-1-top-shape.png"
          alt="shape"
        />
      </div>

      {/* Footer Top */}
      {/* <div className="footer-top">
        <div className="container">
          <div className="footer-top-border">
            <div className="row gy-4 justify-content-between">
              <div className="col-lg-3">
                <div className="logo-top">
                  <a href="index.html">
                    <img
                      src="/img/logo.jpg"
                      alt="Kars"
                    />
                  </a>
                </div>
              </div>

              <div className="col-lg-9">
                <div className="payment-wrap">
                  <div className="info">
                    <h4 className="text-white">Our Payment Methods</h4>
                    <h6>Our Easy And Simple payment methods with cards</h6>
                  </div>
                  <div className="card-thumb-card">
                    <img
                      src="/img/shape/cards.png"
                      alt="cards"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}

      {/* Widgets */}
      <div className="widget-area">
        <div className="container">
          <div className="row justify-content-between">
            {/* About Company */}
            <div className="col-md-3">
              <div className="widget footer-widget">
                <h3 className="widget_title">About Company</h3>
                <div className="th-widget-about">
                  <p className="about-text">
                    Urbania on rent in Pune offers a comfortable and stylish travel experience for group trips, corporate travel, weddings, and airport transfers. With spacious seating, modern interiors, and smooth performance, Force Urbania is perfect for both city and outstation journeys. Enjoy a safe, reliable, and hassle-free ride with flexible rental options
                  </p>

                  <div className="footer-call-wrap">
                    <div className="info-box">
                      <div className="info-contnt">
                        <h4 className="footer-info-title">Call Us:</h4>
                        <p className="info-box_text">
                          <a
                            href="tel:+919209423113"
                            className="info-box_link">
                           +91 9209423113
                          </a>
                        </p>
                        <p className="info-box_text">
                          <a
                            href="tel:+917620411277"
                            className="info-box_link">
                           +91 7620411277
                          </a>
                        </p>
                        <p className="info-box_text">
                          <a
                            href="tel:+919284718314"
                            className="info-box_link">
                           +91 9284718314
                          </a>
                        </p>
                      </div>
                    </div>

                    <div className="info-box">
                      <div className="info-contnt">
                        <h4 className="footer-info-title">Email Us:</h4>
                        <p className="info-box_text">
                          <a
                            href="mailto:booking@urbaniaonrentpune.in  "
                            className="info-box_link"
                          >
                            booking@urbaniaonrentpune.in
                          </a>
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="th-social">
                    <a href="https://www.facebook.com/">
                      <i className="fab fa-facebook-f"></i>
                    </a>
                    <a href="https://www.twitter.com/">
                      <i className="fab fa-twitter"></i>
                    </a>
                    <a href="https://www.linkedin.com/">
                      <i className="fab fa-linkedin-in"></i>
                    </a>
                    <a href="https://www.whatsapp.com/">
                      <i className="fab fa-whatsapp"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>

            {/* Pages */}
            <div className="col-md-3">
              <div className="widget widget_nav_menu footer-widget">
                <h3 className="widget_title">Our Services</h3>
                <ul className="menu">
              <li><a href="urbania-on-rent-pune">Urbania On Rent Pune</a></li>
<li><a href="urbania-on-rent-in-pimpri-chinchwad">Urbania on Rent in Pimpri Chinchwad</a></li>
<li><a href="urbania-hire-for-corporate-events-in-pune">Urbania Hire for Corporate Events in Pune</a></li>
<li><a href="17-seater-urbania-on-rent-in-pune">17 Seater Urbania on Rent in Pune</a></li>
<li><a href="14-seater-urbania-on-rent-in-pune">14 Seater Urbania on Rent in Pune</a></li>
<li><a href="urbania-on-rent-in-kharadi">Urbania on Rent in Kharadi</a></li>
<li><a href="urbania-on-rent-in-hadapsar">Urbania on Rent in Hadapsar</a></li>
<li><a href="urbania-on-rent-in-kothrud">Urbania on Rent in Kothrud</a></li>
<li><a href="urbania-on-rent-in-bibwewadi">Urbania On Rent in Bibwewadi</a></li>
<li><a href="urbania-on-rent-in-koregaon-park" className="d-none">Urbania on Rent in Koregaon Park</a></li>
<li><a href="urbania-on-rent-in-kalyani-nagar" className="d-none">Urbania On Rent in Kalyani Nagar</a></li>
<li><a href="urbania-on-rent-in-mundhwa-pune" className="d-none">Urbania On Rent in Mundhwa Pune</a></li>
<li><a href="urbania-bus-on-rent-in-baner" className="d-none">Urbania Bus On Rent in Baner</a></li>
<li><a href="urbania-ac-bus-on-rent-in-aundh" className="d-none">Urbania Ac Bus On Rent in Aundh</a></li>
<li><a href="urbania-bus-on-rent-in-hinjewadi" className="d-none">Urbania Bus On Rent in Hinjewadi</a></li>
<li><a href="urbania-on-rent-in-bhosari" className="d-none">Urbania on Rent in Bhosari</a></li>
<li><a href="urbania-on-rent-in-pune-station" className="d-none">Urbania on Rent in Pune Station</a></li>
<li><a href="urbania-on-rent-in-chakan" className="d-none">Urbania On Rent in Chakan</a></li>
<li><a href="urbania-on-rent-in-moshi" className="d-none">Urbania On Rent in Moshi</a></li>
<li><a href="urbania-on-rent-in-charholi-budruk" className="d-none">Urbania On Rent in Charholi Budruk</a></li>
<li><a href="urbania-on-rent-in-nigdi-pradhikaran" className="d-none">Urbania On Rent in Nigdi Pradhikaran</a></li>
<li><a href="urbania-on-rent-in-lohegaon">Urbania On Rent in Lohegaon</a></li>
<li><a href="urbania-on-rent-in-wagholi" className="d-none">Urbania On Rent in Wagholi</a></li>
<li><a href="urbania-rental-service-in-pune" className="d-none">Urbania Rental Service in Pune</a></li>
<li><a href="best-urbania-on-rent-in-pune" className="d-none">Best Urbania on Rent in Pune</a></li>
<li><a href="affordable-urbania-on-rent-pune" className="d-none">Affordable Urbania on Rent Pune</a></li>
<li><a href="ac-urbania-on-rent-pune">AC Urbania on Rent Pune</a></li>
<li><a href="luxury-urbania-on-rent-pune" className="d-none">Luxury Urbania on Rent Pune</a></li>
<li><a href="non-ac-urbania-on-rent-pune" className="d-none">Non AC Urbania on Rent Pune</a></li>
<li><a href="urbania-for-outstation-in-pune" className="d-none">Urbania for Outstation in Pune</a></li>
<li><a href="urbania-for-pune-to-shirdi-on-rent" className="d-none">Urbania for Pune to Shirdi On Rent</a></li>
<li><a href="urbania-for-pune-to-nashik-on-rent" className="d-none"> Urbania for Pune to Nashik On Rent</a></li>
<li><a href="urbania-for-pune-to-mahabaleshwar-hire" className="d-none">Urbania for Pune to Mahabaleshwar Hire</a></li>
                  <li><a href="urbania-for-pune-to-goa-tour-package" className="d-none">Urbania for Pune to Goa Tour Package</a></li>
<li><a href="urbania-for-pune-to-kolhapur-on-rent" className="d-none">Urbania for Pune to Kolhapur On Rent</a></li>
<li><a href="urbania-for-pune-to-aurangabad-on-rent" className="d-none">Urbania for Pune to Aurangabad on Rent</a></li>
<li><a href="pune-to-lonavala-urbania-on-rent" className="d-none">Pune to Lonavala Urbania On Rent</a></li>

                </ul>
              </div>
            </div>

            {/* Vehicles */}
            <div className="col-md-3 ">
              <div className="widget widget_nav_menu footer-widget">
                <h3 className="widget_title">Our Services</h3>
                <ul className="menu">
<li><a href="urbania-on-rent-for-round-trip-pune">Urbania On Rent for Round Trip Pune</a></li>

<li><a href="urbania-traveller-rent-in-pune">Urbania Traveller Rent in Pune</a></li>
<li><a href="urbania-monthly-corporate-hire-pune">Urbania Monthly Corporate Hire Pune</a></li>
<li><a href="corporate-urbania-rental-services-pune">Corporate Urbania Rental Services Pune</a></li>
<li><a href="urbania-hire-for-picnic-in-pune">Urbania Hire for Picnic in Pune</a></li>
<li><a href="urbania-hire-for-local-trip-in-pune">Urbania Hire for Local Trip in Pune</a></li>

                 <li><a href="urbania-on-rent-for-pune-airport">Urbania On Rent for Pune Airport</a></li>
<li><a href="pune-to-mumbai-urbania-on-rent">Pune to Mumbai Urbania On Rent</a></li>
<li><a href="urbania-for-wedding-events-in-pune">Urbania for Wedding Events in Pune</a></li>
<li><a href="urbania-per-km-rate-in-pune">Urbania per km rate in Pune</a></li>
<li><a href="cheapest-urbania-rental-service-in-pune" >Cheapest Urbania Rental Service in Pune</a></li>
<li><a href="ac-urbania-on-rent-in-akurdi-pune" className="d-none">AC Urbania on Rent in Akurdi Pune</a></li>
<li><a href="urbania-on-rent-in-wakad" className="d-none">Urbania On Rent in Wakad</a></li>
<li><a href="luxury-urbania-on-rent-in-pashan" className="d-none">Luxury Urbania On Rent in Pashan</a></li>
<li><a href="urbania-on-rent-in-balewadi" className="d-none">Urbania On Rent in Balewadi</a></li>
<li><a href="urbania-on-rent-in-sangvi" className="d-none">Urbania On Rent in Sangvi</a></li>
<li><a href="urbania-bus-hire-in-chikhali" className="d-none">Urbania Bus Hire in Chikhali</a></li>
<li><a href="urbania-on-rent-in-talawade-midc" className="d-none">Urbania On Rent in Talawade MIDC</a></li>
<li><a href="urbania-on-rent-in-purandar-airport" className="d-none">Urbania On Rent in Purandar Airport</a></li>
<li><a href="urbania-on-rent-in-ravet-punawale" className="d-none">Urbania on Rent in Ravet & Punawale</a></li>
<li><a href="urbania-on-rent-in-rajgurunagar-khed" className="d-none">Urbania On Rent in Rajgurunagar Khed</a></li>
<li><a href="urbania-bus-on-rent-in-junnar-pune" className="d-none">Urbania Bus On Rent in Junnar Pune</a></li>
<li><a href="urbania-on-rent-in-ambegaon-pune" className="d-none">Urbania on Rent in Ambegaon Pune</a></li>
<li><a href="urbania-bus-on-rent-in-shirur" className="d-none">Urbania Bus On Rent in Shirur</a></li>
<li><a href="urbania-bus-hire-in-maval" className="d-none">Urbania Bus Hire in Maval</a></li>
<li><a href="urbania-on-rent-in-mulshi" className="d-none">Urbania On Rent in Mulshi</a></li>
<li><a href="urbania-on-rent-in-daund" className="d-none">Urbania On Rent in Daund</a></li>
<li><a href="urbania-on-rent-in-bhor" className="d-none">Urbania On Rent in Bhor</a></li>
<li><a href="urbania-on-rent-in-purandar" className="d-none">Urbania On Rent in Purandar</a></li>
<li><a href="urbania-on-rent-in-indapur" className="d-none">Urbania On Rent in Indapur</a></li>
<li><a href="urbania-on-rent-in-velhe" className="d-none">Urbania On Rent in Velhe</a></li>
<li><a href="urbania-on-rent-in-mumbai" className="d-none">Urbania On Rent in Mumbai</a></li>
<li><a href="force-urbania-on-rent-in-navi-mumbai" className="d-none">Force Urbania On Rent in Navi Mumbai</a></li>
<li><a href="luxury-urbania-bus-hire-in-thane" className="d-none">Luxury Urbania Bus Hire in Thane</a></li>
<li><a href="urbania-bus-on-rent-in-mumbai-airport" className="d-none">Urbania Bus On Rent in Mumbai Airport</a></li>
  <li><a href="luxury-urbania-on-rent-in-lonavala" className="d-none">Luxury Urbania On Rent in Lonavala</a></li>
<li><a href="urbania-on-rent-in-kolhapur" className="d-none">Urbania On Rent in Kolhapur</a></li>

              
                </ul>
              </div>
            </div>

            {/* Brands */}
            <div className=" col-md-3">
              <div className="widget widget_nav_menu footer-widget">
                <h3 className="widget_title">Our Services</h3>
                <ul className="menu">
                <li><a href="urbania-bus-on-rent-in-sangli">Urbania Bus On Rent in Sangli</a></li>
<li><a href="urbania-bus-on-rent-in-solapur">Urbania Bus On Rent in Solapur</a></li>
<li><a href="urbania-bus-on-rent-in-shirdi">Urbania Bus On Rent in Shirdi</a></li>
<li><a href="luxury-urbania-bus-rentals-in-nashik" >Luxury Urbania Bus Rentals in Nashik</a></li>
<li><a href="luxury-urbania-rentals-in-ahmednagar" >Luxury Urbania Rentals in Ahmednagar</a></li>
<li><a href="ac-luxury-urbania-hire-in-mahabaleshwar" >AC Luxury Urbania Hire in Mahabaleshwar</a></li>
<li><a href="pune-to-konkan-darshan-urbania-bus-package" >Pune to Konkan Darshan Urbania Bus Package</a></li>
<li><a href="mini-bus-on-rent-in-pune" >Mini Bus On Rent in Pune</a></li>
<li><a href="mini-bus-on-rental-in-pimpri-chinchwad" >Mini Bus On Rental in Pimpri Chinchwad</a></li>
<li><a href="15-seater-ac-mini-luxury-bus-on-rent-pune" >15 Seater AC Mini Luxury Bus On Rent Pune</a></li>
<li><a href="force-urbania-on-rent-in-satara" className="d-none">Force Urbania On Rent in Satara</a></li>
<li><a href="force-urbania-on-rent-in-katraj-pune"className="d-none" >Force Urbania on Rent in Katraj Pune</a></li>
<li><a href="force-urbania-on-rent-in-shivaji-nagar-pune" className="d-none">Force Urbania On Rent in Shivaji Nagar Pune</a></li>
<li><a href="urbania-on-rent-for-jyotirlinga-darshan-from-pune" className="d-none">Urbania on Rent for Jyotirlinga Darshan from Pune</a></li>
<li><a href="pune-to-ujjain-urbania-bus-hire" className="d-none">Pune to Ujjain Urbania Bus Hire</a></li>
<li><a href="pune-to-ashtavinayak-darshan-urbania-bus" className="d-none">Pune to Ashtavinayak Darshan Urbania Bus</a></li>
<li><a href="urbania-tourist-bus-on-rent-in-pune" className="d-none">Urbania Tourist Bus On Rent in Pune</a></li>
<li><a href="pune-to-pandharpur-urbania-tour-package" className="d-none">Pune to Pandharpur Urbania Tour Package</a></li>
<li><a href="urbania-bus-on-rent-in-nashik" className="d-none">Urbania Bus On Rent in Nashik</a></li>
<li><a href="pune-to-ayodhya-urbania-bus-on-rent" className="d-none">Pune to Ayodhya Urbania Bus On Rent</a></li>
<li><a href="pune-to-bhimashankar-urbania-hire" className="d-none">Pune to Bhimashankar Urbania Hire</a></li>
<li><a href="pune-to-hyderabad-urbania-on-rent" className="d-none">Pune to Hyderabad Urbania On Rent</a></li>
<li><a href="pune-to-bangalore-urbania-rental-service" className="d-none">Pune to Bangalore Urbania Rental Service</a></li>
<li><a href="pune-to-rajasthan-urbania-rental-service" className="d-none">Pune to Rajasthan Urbania Rental Service</a></li>
<li><a href="bus-on-rent-pune" className="d-none">Bus On Rent Pune</a></li>
<li><a href="urbania-on-rent-in-aurangabad" className="d-none">Urbania On Rent in Aurangabad</a></li>
<li><a href="bus-hire-for-wedding-in-pune" className="d-none">Bus Hire for Wedding in Pune</a></li>
<li><a href="urbania-on-rent-pune-for-wedding-functions" className="d-none">Urbania on Rent Pune for Wedding Functions</a></li>
<li><a href="pune-to-outstation-urbania-on-rent" className="d-none">Pune to Outstation Urbania on Rent</a></li>
<li><a href="urbania-bus-on-rent-in-punawale" className="d-none">Urbania Bus on Rent in Punawale</a></li>
<li><a href="urbania-hire-in-pimpri-for-corporate-travel" className="d-none">Urbania Hire in Pimpri for Corporate Travel</a></li>
<li><a href="urbania-on-rent-in-pune-contact-number" className="d-none">Urbania on Rent in Pune Contact Number</a></li>
<li><a href="bus-rental-service-in-saswad-pune" className="d-none">Bus Rental Service in Saswad Pune</a></li>
<li><a href="pune-to-nashik-urbania-bus-hire" className="d-none">Pune to Nashik Urbania Bus Hire</a></li>
                 <li><a href="9-seater-urbania-on-rent-in-pune" className="d-none">9 Seater Urbania On Rent in Pune</a></li>
<li><a href="13-seater-urbania-on-rent-in-pune" className="d-none">13 Seater Urbania On rent in pune</a></li>
<li><a href="10-seater-urbania-on-rent-in-pune" className="d-none">10 Seater Urbania On Rent in pune</a></li>
                </ul>
              </div>
            </div>

          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="copyright-wrap">
        <div className="container">
          <p className="copyright-text text-white text-center">
              © Copyright &copy;  <span className="darkcolorrr">Urbania On Rebt in Pune</span> <span id="date">{new Date().getFullYear()}</span>{' '}
                <span href="#"> Developed By </span> <a href="https://www.dexterintelligence.com/" className='d-inline' target="_blank" rel="noopener noreferrer">
                <span className="darkcolorrr">&nbsp;Dexter Intelligence</span>
              </a>
               | Hosted By <a href="https://www.urvahosting.com/" className='d-inline ' target="_blank" rel="noopener noreferrer"> <span className="darkcolorrr">&nbsp;Urva Hosting</span> </a>
              </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;